import * as React from 'react';
import PropTypes from 'prop-types';

function EmailIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  const { color = '#192A51', width = 24, height = 24 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#clip0_1416_4185)"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M8 12a4 4 0 108 0 4 4 0 00-8 0z" />
        <path d="M16 12v1.5a2.5 2.5 0 105 0V12a9 9 0 10-5.5 8.28" />
      </g>
      <defs>
        <clipPath id="clip0_1416_4185">
          <path fill="#fff" d="M0 0H24V24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
EmailIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default EmailIcon;
